export type IndicateurTitleKeys = keyof typeof IndicateurTitle;

export const IndicateurTitle = {
  volet1: 'PAGECTE: 4 Ans Du 01 Février 2024 Au 31 Janvier 2028',
  volet2: 'LOCAL: 5 Ans Du 28 Février 2023 Au 27 Février 2028',
  volet3: "GREENOV'I: 5 Ans Du 01 Février 2023 Au 31 Janvier 2028",
  volet4: 'ARESSE: 4 Ans Du 01 Septembre 2023 Au 31 Août 2027',
  program:
    "PAAET: Mise En Œuvre Des Volets Du 1er Février 2023 (GREENOV'I) Au 27 Février 2028 (LOCAL)",
};
